import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/ui/Button'
import { LeftArrowWhite } from '../../assets/images/svg/LeftArrow'
import { CameraWhite } from "../../assets/images/svg/Camera"
import { UploadSorrell } from "../../assets/images/svg/Upload"
import { observer } from 'mobx-react';
import { applicationStore } from 'src/store/ApplicationStore';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';


const ContinueOnAnotherDevice = observer(() => {
    const navigate = useNavigate();
    const returnUrl = sessionStorage.getItem("returnUrl");
    const qrValue = `${window?.location?.origin}/?aid=${applicationStore.aidCode}${returnUrl ? `&returnUrl=${encodeURIComponent(returnUrl)}` : ""
        }`;
    const { t } = useTranslation();
    return (
        <div className="custom-container">
            <div className="flex justify-between flex-col items-center h-full">
                <div>
                    <div className='text-left'>
                        <Button className="" variant="primaryBack" onClick={() => { navigate(applicationStore.previousRoute.continueOnAnotherDevice, { replace: true }) }}><LeftArrowWhite /></Button>
                    </div>
                    <div className='grid gap-[16px] mt-10'>
                        <div className="text-h5 font-bold text-flow-heading">{t('continueAnother.title')}</div>
                        <div className="text-body text-Gray900">{t('continueAnother.description.generic')}</div>
                    </div>
                    <div className='mt-4 w-[313px] h-[242px] bg-Carrara50 rounded-[16px] flex justify-center flex-col items-center'>
                        <figure className='w-[160px] h-[160px]'>
                            <QRCode
                                style={{ height: "auto", maxWidth: "100%", width: "100%", bgColor: "#FFFFFF", fgColor: "#26273b" }}
                                value={qrValue}
                            />
                        </figure>
                    </div>
                    <div className='mt-6 grid gap-2'>
                        <Button onClick={() => { navigate("/continue-on-another-device-email", { replace: true }) }} className="" variant="primaryWithIcon"><CameraWhite /><span className="ms-2">{t('continueAnother.sendEmail')}</span></Button>
                        <div className='group'>
                            <Button
                                onClick={() => { navigate("/continue-on-another-device-sms", { replace: true }) }}
                                className="group-hover:bg-SorrellBrown4000 group-hover:text-Gray50"
                                variant="secondaryWithIcon">
                                <UploadSorrell />
                                <span className="ms-2 group-hover:text-Gray50">{t('continueAnother.sendSms')}</span>
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="">

                </div>
            </div>
        </div>
    )
})

export default ContinueOnAnotherDevice
